import Glob from "./Glob.mjs";

const cache = { data: {} };

const appLib = {};

/**
 * @private
 * @param {string|Object} path
 * @param {Object} [data]
 * @param {Object} [xh] X-Headers
 * @return {Promise<Object>}
 */
const api = async ( path, data = {}, xh = {} ) => {
	const params = {};
	if ( typeof path === 'object') {
		Object.assign(path,params);
		path = `${path.entity || 'ollivud' }/${path.operation}`;
	}
	const u = appLib.currentUser();
	if ( u?.id ) {
		params.userid = u.id ;
		if ( u?.session ) params.session = u.session;
	}
	if ( path.startsWith('/') ) path = path.slice(1);
	let out;
	try {
		out = await Glob.api( path, { params: params, data: data }, xh );
	} catch ( e ) {
		if ( u?.id && e?.message.startsWith( '4' ) ) {
			const code = Number(e.message.slice( 0, 3 ));
			if ( code === 401 || code === 403 ) appLib.logout();
		}
		throw e;
	}
	return out;
}

appLib.dataCache = ( dataID ) => Glob.clone( (cache?.data||{})[dataID]?.content || JSON.parse(window.localStorage.getItem('lastFetch-'+dataID) || 'false') );

appLib.currentUser = ( u ) => {
	if ( u?.id && u?.session ) {
		Glob.setStatus('currentUser', u, true);
		Glob.trigger('userChangeOccurred');
	}
	return Glob.getStatus('currentUser');
}

appLib.logout = () => {
	Glob.setStatus('currentUser', undefined, true);
	Glob.trigger('userLogoutOccurred');
}

/**
 * @function
 * @async
 * @param {string|Object} path
 * @param {Object} [data]
 * @param {Object} [xh] X-Headers
 * @return {Promise<Object>}
 */
appLib.api = async ( path, data, xh ) => {
	return api( path, data, xh );
};

const dataFetchMinutesDelay = {
	meteo: 300,
	data: 120,
	links: 300
};

/**
 * @function
 * @async
 * @param {string} dataID
 * @param {boolean} [live_fetch]
 * @return {Promise<Object>}
 * @throws {Error}
 */
appLib.data = ( dataID, live_fetch = false) => {
	if ( ! live_fetch ) {
		if ( ! cache?.data ) cache.data = {};
		if ( ! cache.data[ dataID ] ) cache.data[ dataID ] = {};
	}
	return new Promise( ( resolve,reject ) => {
		if ( ! live_fetch ) {
			if ( cache.data[ dataID ].loading )
				return setTimeout( ()=>{ appLib.data(dataID).then( x => resolve( x ) ).catch( err => reject( err ) ); }, 50 );
			const delay = (dataFetchMinutesDelay[dataID] ?? 15) * 60000;
			const now = (new Date()).getTime();
			if ( cache?.data && cache.data[ dataID ] && cache.data[ dataID ]?.content ) {
				const lu = cache.data[ dataID ]?.lastUpdate || 0;
				if ( (now - lu) < delay ) return resolve( Glob.clone( cache.data[ dataID ]?.content ) );
			}
			cache.data[ dataID ].loading = true;
		}
		const uri = Glob.prop.uri.web + 'data/' + dataID + '.json';
		const init = {
			cache: 'no-cache',
			method: 'GET',
			headers: {
				'Content-Type': 'application/json; charset=UTF-8',
				accept: 'application/json; charset=UTF-8, application/xml; charset=UTF-8',
				pragma: 'no-cache',
				'cache-control': 'no-cache',
			}
		};
		init.headers[Glob.prop.xAppHeader] = Glob.prop.keyApplicationName;
		fetch( uri, init ).then( result => {
			return result.json();
		}).then( data => {
			if ( live_fetch ) {
				resolve( data );
			} else {
				cache.data[ dataID ].content = data;
				cache.data[ dataID ].lastUpdate = (new Date()).getTime();
				window.localStorage.setItem('lastFetch-'+dataID, JSON.stringify( data ) );
				resolve( Glob.clone(cache.data[ dataID ].content) );
			}
		}).catch( err => {
			console.error( err );
			const odata = live_fetch ? false : window.localStorage.getItem('lastFetch-'+dataID);
			if ( odata ) {
				resolve( JSON.parse( odata ) );
			} else {
				reject( err );
			}
		}).finally( ()=>{
			if ( ! live_fetch ) delete cache.data[ dataID ].loading;
		});
	});
}

/**
 * @function
 * @param {Record<string,string>|string|number} txt
 * @return {string}
 */
appLib.text = ( txt ) => {
	txt = ( x => {
		if (typeof x === 'string') return x;
		if (typeof x === 'number') return String(x);
		if (typeof x === 'object') {
			const cl = Glob.getLanguage();
			if (x[cl]) return x[cl];
			for (let k in Object.keys(x)) {
				if (x[k]) return x[k];
			}
			return '';
		}
	})(txt)
	return txt;
}

export default appLib;